import { Link } from 'react-router-dom';
import spacetime from 'spacetime';

import { ROUTE_PLAN_BY_ID, ROUTE_KNM_LIST_WITH_PLAN } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { getPlanErknmStatusByStatusTitle } from 'APIPackage/PlanListModule/common/getPlanErknmStatusByStatusTitle';
import {
  getIsPlanErknmStatusInProcess,
  getIsPlanErknmStatusUnderConsideration,
  getIsPlanErknmStatusConsidered,
} from 'APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { ErknmPlanStatusTitlesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusTitlesEnum';
import { tzMoscow } from 'CorePackage/MainModule/constants/timeZone';
import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';

import styles from './PlanListTable.module.scss';
import { IKnmPlan } from '../interfaces/IKnmPlan';

interface IRenderTooltipTextPlanId {
  knoId?: string;
  statusTitle?: ErknmPlanStatusTitlesEnum;
  isEmpty?: boolean;
  isSupervisor?: boolean;
  isProsecutor?: boolean;
  isSuperProsecutor?: boolean;
  knoOrganisations?: IUserOrganisation[];
}

const renderTooltipTextPlanId = ({
  knoId,
  statusTitle,
  isEmpty,
  knoOrganisations,
  isSupervisor,
  isProsecutor,
  isSuperProsecutor,
}: IRenderTooltipTextPlanId) => {
  const userDate = spacetime.now(tzMoscow);
  const isCompareDefaultKnoWithCurrent = knoOrganisations?.find(item => item.byDefault)?.id === knoId?.toString();
  const planErknmStatus = getPlanErknmStatusByStatusTitle(statusTitle);
  const isPlanErknmStatusInProcess: boolean = getIsPlanErknmStatusInProcess(planErknmStatus);
  const isPlanErknmStatusUnderConsideration: boolean = getIsPlanErknmStatusUnderConsideration(planErknmStatus);
  const isPlanErknmStatusConsidered: boolean = getIsPlanErknmStatusConsidered(planErknmStatus);
  const currentYear = new Date().getFullYear();
  let text = '';

  if (!isEmpty) {
    if (isSupervisor && isCompareDefaultKnoWithCurrent) {
      if (
        isPlanErknmStatusInProcess &&
        userDate.isAfter(spacetime(`September 20 ${currentYear}`, tzMoscow)) &&
        userDate.isBefore(spacetime(`October 2 ${currentYear}`, tzMoscow))
      ) {
        text = 'Данный план готов к рассмотрению, но не направлен в прокуратуру';
      }
      if (
        isPlanErknmStatusConsidered &&
        userDate.isAfter(spacetime(`December 5 ${currentYear}`, tzMoscow)) &&
        userDate.isBefore(spacetime(`December 16 ${currentYear}`, tzMoscow))
      ) {
        text = 'Данный план рассмотрен, но не утвержден';
      }
    }
    if (
      (isProsecutor || isSuperProsecutor) &&
      isCompareDefaultKnoWithCurrent &&
      isPlanErknmStatusUnderConsideration &&
      userDate.isAfter(spacetime(`October 22 ${currentYear}`, tzMoscow)) &&
      userDate.isBefore(spacetime(`November 2 ${currentYear}`, tzMoscow))
    ) {
      text = 'Данный план не рассмотрен';
    }
  }

  return text;
};

export const PlanListPlanIdCell = ({
  value,
  row,
  isErknm,
  isProsecutor,
  isSuperProsecutor,
  isSupervisor,
  knoOrganisations,
  isTest,
}: ITableRenderCell<IKnmPlan>) => {
  const currentValue = typeof value === 'number' || typeof value === 'string' ? value : '';
  const tooltip = renderTooltipTextPlanId({
    knoId: row.knoId,
    statusTitle: row.erknmStatus || undefined,
    isEmpty: !row.knmAmount,
    knoOrganisations,
    isSupervisor,
    isProsecutor,
    isSuperProsecutor,
  });

  return (
    <div className={styles.TooltipContainer}>
      <Link
        className="shared-table-link"
        to={
          isErknm
            ? ROUTE_PLAN_BY_ID(currentValue, `backUrl=${encodeURI(window.location.pathname)}`)
            : ROUTE_KNM_LIST_WITH_PLAN(currentValue)
        }
        target={isErknm ? '' : '_blank'}
      >
        {currentValue}
      </Link>
      {isTest && <span className={styles.TestUserWrapper}>ТЕСТ</span>}
      {tooltip && (
        <Tooltip placement="right" content={<div className={styles.TooltipContent}>{tooltip}</div>}>
          <span className={styles.TooltipIcon}>!</span>
        </Tooltip>
      )}
    </div>
  );
};
